export default from './root';



// WEBPACK FOOTER //
// ./app/containers/root/index.js